import { NavigateFunction } from "react-router-dom";
import { supabase } from "../SupabaseClient.tsx";

// Status ID for receipts uploaded by email that still need confirmation
const DRAFT_STATUS_ID = 1;

// Count email uploaded receipts that still need review
export async function countDraftReceipts(): Promise<number> {
  const { count, error } = await supabase
    .from("orders")
    .select("id", { count: "exact", head: true })
    .eq("status_id", DRAFT_STATUS_ID);

  if (error) {
    console.error("Error counting draft receipts:", error);
    return 0;
  }

  return count ?? 0;
}

// Open the Receipt Library filtered to receipts that need review
export function viewDraftReceipts(navigate: NavigateFunction) {
  sessionStorage.setItem("showDraftsOnly", "true");
  sessionStorage.setItem("receiptCurrentPage", "1");
  navigate("/receipt-library");
}
